import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private isRedirecting = false;

  constructor(
    private router: Router,
    private auth: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    // If already redirecting to Auth0, prevent any route activation
    if (this.isRedirecting) {
      return of(false);
    }

    return from(this.auth.isAuthenticated())
      .pipe(
        map((authenticated: boolean) => {
          if (authenticated) {
            return true;
          }

          // Set flag to prevent multiple redirects and route activations
          this.isRedirecting = true;

          // Save the attempted URL for redirect after login
          localStorage.setItem('redirectUrl', state.url);

          // Initiate Auth0 login redirect
          // This is async but we don't wait - the redirect will happen
          this.auth.login().catch(err => {
            console.error('Error initiating login:', err);
            this.isRedirecting = false;
          });

          // Immediately return false to prevent route activation
          return false;
        }),
        catchError((error) => {
          console.error('Error checking authentication:', error);
          this.isRedirecting = true;
          this.auth.login().catch(err => {
            console.error('Error initiating login after auth check failure:', err);
            this.isRedirecting = false;
          });
          return of(false);
        })
      );
  }
}
